export const calendarConfig = {
  sameDay: '[Heute]',
  lastDay: '[Gestern]',
  lastWeek: 'DD.MM.YYYY',
};
